import { ref } from 'vue'
import { defineStore } from 'pinia'
import { minutesToMilliseconds } from 'date-fns'
import { cacheApi } from '../api/cache.api'

export const useCacheStore = defineStore('cache', () => {
  const timerId = ref<NodeJS.Timeout>()
  const hasApplicationSettingUpdate = ref<boolean>(false)
  const hasClientSettingUpdate = ref<boolean>(false)
  const hasUserUpdate = ref<boolean>(false)
  const lastUpdated = ref<string>(new Date().toISOString())

  const checkStatus = async (): Promise<void> => {
    const { data } = await cacheApi.checkStatus(lastUpdated.value)
    if (data) {
      hasApplicationSettingUpdate.value = data.hasApplicationSettingUpdate
      hasClientSettingUpdate.value = data.hasClientUpdate
      hasUserUpdate.value = data.hasUserUpdate
    }
    lastUpdated.value = new Date().toISOString()
  }

  const clearTimer = (): void => {
    if (timerId.value) {
      clearTimeout(timerId.value)
    }
  }

  const startCacheUpdate = (): void => {
    clearTimer()
    timerId.value = setTimeout(() => {
      checkStatus()
      startCacheUpdate()
    }, minutesToMilliseconds(1))
  }

  return {
    hasApplicationSettingUpdate,
    hasClientSettingUpdate,
    hasUserUpdate,
    startCacheUpdate,
  }
})
